module.exports = __webpack_public_path__ + "img/olfativa.81f335aa.png";